import { render, staticRenderFns } from "./Troubles.vue?vue&type=template&id=0e6164cb&scoped=true"
import script from "./Troubles.vue?vue&type=script&lang=js"
export * from "./Troubles.vue?vue&type=script&lang=js"
import style0 from "./Troubles.vue?vue&type=style&index=0&id=0e6164cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6164cb",
  null
  
)

export default component.exports